import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { FilesTab } from '../../FilesTab';
import { AmendmentImpactReview } from '../amendment/AmendmentImpactReview';
import { ProposalFileQAPanel } from '../fileQA/ProposalFileQAPanel';
import { SolicitationOfRecordPanel } from '../sources/SolicitationOfRecordPanel';
import { useV2ProposalProjectDetail } from '../useV2ProposalProjectDetail';
import { proposalLoadErrorMessage } from './proposalLoadError';
export function SourcesFilesPage() {
    const { id } = useParams();
    const { projectDetail, isLoading, error } = useV2ProposalProjectDetail(id);
    if (isLoading) {
        return /*#__PURE__*/ _jsx("div", {
            className: "p-8 text-sm text-slate-500",
            children: "Loading project..."
        });
    }
    if (error || !projectDetail) {
        return /*#__PURE__*/ _jsx("div", {
            className: "p-8 text-sm text-rose-600",
            children: proposalLoadErrorMessage(error)
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "p-4 sm:p-6 lg:p-8",
        children: [
            /*#__PURE__*/ _jsx(AmendmentImpactReview, {
                projectId: projectDetail.projectId
            }),
            /*#__PURE__*/ _jsx(SolicitationOfRecordPanel, {
                projectId: projectDetail.projectId
            }),
            /*#__PURE__*/ _jsx(ProposalFileQAPanel, {
                projectId: projectDetail.projectId
            }),
            /*#__PURE__*/ _jsx(FilesTab, {
                projectId: projectDetail.projectId,
                userRole: projectDetail.role,
                isArchived: projectDetail.status === 'archived'
            })
        ]
    });
}
